import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/index.css';
import "./assets/styles/sidebar.css";
import RoutesIndex from './routes/RoutesIndex';
import { DataProvider } from './services/DataContext';

const Index = () => {
  return (
    <React.StrictMode>
      <DataProvider>
        <RoutesIndex />
      </DataProvider>
    </React.StrictMode>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<Index />);
